import React from "react";

import Button from "../../Button";

import { getDestination, getSystemSettings, setDestination } from "../../../utils/SettingsRetriever";
import PushHistory from '../../../utils/PushHistory';

import "./index.scss";

export default class MultiDestination extends React.Component{
    constructor(props){
        super(props);

        this.state = {
            destination: undefined
        }
    }
    componentDidMount(){
        document.addEventListener("destinationUpdate", this.handleNewDestination, false);
        if (getDestination()){
            this.setState({ destinations: getDestination()})
        }
    }

    componentWillUnmount(){
        document.removeEventListener("destinationUpdate", this.handleNewDestination, false);
    }

    handleNewDestination = () => {
       this.setState({ destinations: getDestination() })
    }

    getDestinationName = (destinationID) => {
        let { multiDestination } = getSystemSettings();
        if (multiDestination && multiDestination.list){
            let destination = multiDestination.list.find(dest => dest.id === parseInt(destinationID))
            if (destination) return destination.name;
        }
        return null;
    }

    changeDestination = () => {
        setDestination([]);
        PushHistory("/select_destination");
    }

    render(){
        const { getDestinationName, state } = this;
        const { destinations } = state;

        if (destinations && destinations.length > 0){
            if (destinations.length > 3){
                return (
                  <div onMouseLeave={() => this.setState({ displayDestinations: false})} className="selectedDestination">
                    You are searching in <strong onMouseEnter={() => this.setState({ displayDestinations: true})}>Multiple destinations</strong>
                    {
                      this.state.displayDestinations &&
                        <div className="destinationsToolTip">
                          {
                            getSystemSettings().multiDestination.list.map(destination => {
                              if ( destinations.find( dest => parseInt(dest) === parseInt(destination.id) ) ) {
                                return <div><strong key={destination.id}>{" " + destination.name + " "}</strong></div>
                              }
                              return null;
                            })
                          }
                        </div>
                    }
                    <Button onClick={() => this.changeDestination()}>
                        Change Destination
                    </Button>
                  </div>
                )
            } else {
                return (
                    <div className={"selectedDestination"}>
                        Currently on 
                        {
                            destinations.map((destination, index) => {
                                return ` ${getDestinationName(destination) + (index + 1 < destinations.length ? "," : "")}`
                            })
                        }
                        <Button onClick={() => this.changeDestination()}>
                            Change Destination
                        </Button>
                    </div>
                )
            }
        }

        return null;
    }
}